<h2 mat-dialog-title>Comment</h2>
<mat-dialog-content class="mat-typography">
  Comment is not available now ~
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>OK!</button>
</mat-dialog-actions>